(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallStatusDialogController', PhoneCallStatusDialogController);

    PhoneCallStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCallStatus'];

    function PhoneCallStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCallStatus) {
        var vm = this;

        vm.phoneCallStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallStatus.id !== null) {
                PhoneCallStatus.update(vm.phoneCallStatus, onSaveSuccess, onSaveError);
            } else {
                PhoneCallStatus.save(vm.phoneCallStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
